<template>
  <f7-navbar>
    <f7-nav-title>Softresource</f7-nav-title>
    <f7-nav-right>
      <f7-link href="#about" class="external">O nás</f7-link>
      <f7-link href="#references" class="external">Reference</f7-link>
      <f7-link href="#clients" class="external">Naši klienti</f7-link>
      <f7-link href="#contact" class="external">Kontakt</f7-link>
    </f7-nav-right>
  </f7-navbar>
</template>

<script>
export default {};
</script>

<style>
.link {
  color: #000 !important;
}
.navbar{
    position: fixed;
}

.navbar .title{

}
.navbar-inner{
    max-width: 1080px;
    margin: 0 auto;
    position: relative !important;
}
@media screen and (max-width: 426px) {
   .link{
    font-size: 14px;
   }
   .title{
       display: none !important;
    }
    .right{
        margin: 0 auto !important;
    }
}
</style>